import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // ------ merchant initial-------- //
  merchantListStatus: STATUS.DEFAULT,
  merchantListResult: null,
  merchantListErrorMessage: "",

  addMerchantStatus: STATUS.DEFAULT,
  addMerchantResult: null,
  addMerchantErrorMessage: "",

  createMerchantAccountStatus: STATUS.DEFAULT,
  createMerchantAccountResult: null,
  createMerchantAccountErrorMessage: "",

  updateMerchantAccountStatus: STATUS.DEFAULT,
  updateMerchantAccountResult: null,
  updateMerchantAccountErrorMessage: "",

  viewMerchantStatus: STATUS.DEFAULT,
  viewMerchantResult: null,
  viewMerchantErrorMessage: "",

  activateMerchantStatus: STATUS.DEFAULT,
  activateMerchantResult: null,
  activateMerchantErrorMessage: "",

  deactivateMerchantStatus: STATUS.DEFAULT,
  deactivateMerchantResult: null,
  deactivateMerchantErrorMessage: "",

  merchantTransactionsStatus: STATUS.DEFAULT,
  merchantTransactionsResult: null,
  merchantTransactionsErrorMessage: "",

  viewMerchantTransactionStatus: STATUS.DEFAULT,
  viewMerchantTransactionResult: null,
  viewMerchantTransactionErrorMessage: "",

  merchantPropertiesStatus: STATUS.DEFAULT,
  merchantPropertiesResult: null,
  merchantPropertiesErrorMessage: "",

  createMerchantPropertyStatus: STATUS.DEFAULT,
  createMerchantPropertyResult: null,
  createMerchantPropertyErrorMessage: "",

  updateMerchantPropertyStatus: STATUS.DEFAULT,
  updateMerchantPropertyResult: null,
  updateMerchantPropertyErrorMessage: "",

  deleteMerchantPropertyStatus: STATUS.DEFAULT,
  deleteMerchantPropertyResult: null,
  deleteMerchantPropertyErrorMessage: "",
};

const merchantReducers = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *-------- > merchant list reducers
    case OP.MERCHANT_LIST_LOADING:
      return {
        ...state,
        merchantListStatus: STATUS.LOADING,
      };
    case OP.MERCHANT_LIST_SUCCESS:
      return {
        ...state,
        merchantListStatus: STATUS.SUCCESS,
        merchantListResult: payload,
        merchantListErrorMessage: "",
      };
    case OP.MERCHANT_LIST_FAILURE:
      return {
        ...state,
        merchantListStatus: STATUS.ERROR,
        merchantListResult: null,
        merchantListErrorMessage: payload,
      };
    case OP.MERCHANT_LIST_RESET:
      return {
        ...state,
        merchantListStatus: STATUS.DEFAULT,
        merchantListResult: null,
        merchantListErrorMessage: "",
      };

    // *-------- > add merchant reducers
    case OP.ADD_MERCHANT_LOADING:
      return {
        ...state,
        addMerchantStatus: STATUS.LOADING,
      };
    case OP.ADD_MERCHANT_SUCCESS:
      return {
        ...state,
        addMerchantStatus: STATUS.SUCCESS,
        addMerchantResult: payload,
        addMerchantErrorMessage: "",
      };
    case OP.ADD_MERCHANT_FAILURE:
      return {
        ...state,
        addMerchantStatus: STATUS.ERROR,
      };
    case OP.ADD_MERCHANT_RESET:
      return {
        ...state,
        addMerchantStatus: STATUS.DEFAULT,
        addMerchantResult: null,
        addMerchantErrorMessage: "",
      };

    // *-------- > create merchant account reducers
    case OP.CREATE_MERCHANT_ACCOUNT_LOADING:
      return {
        ...state,
        createMerchantAccountStatus: STATUS.LOADING,
      };
    case OP.CREATE_MERCHANT_ACCOUNT_SUCCESS:
      return {
        ...state,
        createMerchantAccountStatus: STATUS.SUCCESS,
        createMerchantAccountResult: payload,
        createMerchantAccountErrorMessage: "",
      };
    case OP.CREATE_MERCHANT_ACCOUNT_FAILURE:
      return {
        ...state,
        createMerchantAccountStatus: STATUS.ERROR,
        createMerchantAccountResult: null,
        createMerchantAccountErrorMessage: payload,
      };
    case OP.CREATE_MERCHANT_ACCOUNT_RESET:
      return {
        ...state,
        createMerchantAccountStatus: STATUS.DEFAULT,
        createMerchantAccountResult: null,
        createMerchantAccountErrorMessage: "",
      };

    // *-------- > update merchant account reducers
    case OP.UPDATE_MERCHANT_ACCOUNT_LOADING:
      return {
        ...state,
        updateMerchantAccountStatus: STATUS.LOADING,
      };
    case OP.UPDATE_MERCHANT_ACCOUNT_SUCCESS:
      return {
        ...state,
        updateMerchantAccountStatus: STATUS.SUCCESS,
        updateMerchantAccountResult: payload,
        updateMerchantAccountErrorMessage: "",
      };
    case OP.UPDATE_MERCHANT_ACCOUNT_FAILURE:
      return {
        ...state,
        updateMerchantAccountStatus: STATUS.ERROR,
        updateMerchantAccountResult: null,
        updateMerchantAccountErrorMessage: payload,
      };
    case OP.UPDATE_MERCHANT_ACCOUNT_RESET:
      return {
        ...state,
        updateMerchantAccountStatus: STATUS.DEFAULT,
        updateMerchantAccountResult: null,
        updateMerchantAccountErrorMessage: "",
      };

    // *-------- > view merchant reducers
    case OP.VIEW_MERCHANT_LOADING:
      return {
        ...state,
        viewMerchantStatus: STATUS.LOADING,
      };
    case OP.VIEW_MERCHANT_SUCCESS:
      return {
        ...state,
        viewMerchantStatus: STATUS.SUCCESS,
        viewMerchantResult: payload,
        viewMerchantErrorMessage: "",
      };
    case OP.VIEW_MERCHANT_FAILURE:
      return {
        ...state,
        viewMerchantStatus: STATUS.ERROR,
        viewMerchantResult: null,
        viewMerchantErrorMessage: payload,
      };
    case OP.VIEW_MERCHANT_RESET:
      return {
        ...state,
        viewMerchantStatus: STATUS.DEFAULT,
        viewMerchantResult: null,
        viewMerchantErrorMessage: "",
      };

    // *-------- > activate merchant reducers
    case OP.ACTIVATE_MERCHANT_LOADING:
      return {
        ...state,
        activateMerchantStatus: STATUS.LOADING,
      };
    case OP.ACTIVATE_MERCHANT_SUCCESS:
      return {
        ...state,
        activateMerchantStatus: STATUS.SUCCESS,
        activateMerchantResult: payload,
        activateMerchantErrorMessage: "",
      };
    case OP.ACTIVATE_MERCHANT_FAILURE:
      return {
        ...state,
        activateMerchantStatus: STATUS.ERROR,
      };
    case OP.ACTIVATE_MERCHANT_RESET:
      return {
        ...state,
        activateMerchantStatus: STATUS.DEFAULT,
        activateMerchantResult: null,
        activateMerchantErrorMessage: "",
      };

    // *-------- > deactivate merchant reducers
    case OP.DEACTIVATE_MERCHANT_LOADING:
      return {
        ...state,
        deactivateMerchantStatus: STATUS.LOADING,
      };
    case OP.DEACTIVATE_MERCHANT_SUCCESS:
      return {
        ...state,
        deactivateMerchantStatus: STATUS.SUCCESS,
        deactivateMerchantResult: null,
        deactivateMerchantErrorMessage: "",
      };
    case OP.DEACTIVATE_MERCHANT_FAILURE:
      return {
        ...state,
        deactivateMerchantStatus: STATUS.ERROR,
      };
    case OP.DEACTIVATE_MERCHANT_RESET:
      return {
        ...state,
        deactivateMerchantStatus: STATUS.DEFAULT,
        deactivateMerchantResult: null,
        deactivateMerchantErrorMessage: "",
      };

    // *-------- > merchant transactions reducers
    case OP.MERCHANT_TRANSACTIONS_LOADING:
      return {
        ...state,
        merchantTransactionsStatus: STATUS.LOADING,
      };
    case OP.MERCHANT_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        merchantTransactionsStatus: STATUS.SUCCESS,
        merchantTransactionsResult: payload,
        merchantTransactionsErrorMessage: "",
      };
    case OP.MERCHANT_TRANSACTIONS_FAILURE:
      return {
        ...state,
        merchantTransactionsStatus: STATUS.ERROR,
        merchantTransactionsResult: null,
        merchantTransactionsErrorMessage: payload,
      };
    case OP.MERCHANT_TRANSACTIONS_RESET:
      return {
        ...state,
        merchantTransactionsStatus: STATUS.DEFAULT,
        merchantTransactionsResult: null,
        merchantTransactionsErrorMessage: "",
      };

    // *-------- > merchant properties reducers
    case OP.MERCHANT_PROPERTIES_LOADING:
      return {
        ...state,
        merchantPropertiesStatus: STATUS.LOADING,
      };
    case OP.MERCHANT_PROPERTIES_SUCCESS:
      return {
        ...state,
        merchantPropertiesStatus: STATUS.SUCCESS,
        merchantPropertiesResult: payload,
        merchantPropertiesErrorMessage: "",
      };
    case OP.MERCHANT_PROPERTIES_FAILURE:
      return {
        ...state,
        merchantPropertiesStatus: STATUS.ERROR,
        merchantPropertiesResult: null,
        merchantPropertiesErrorMessage: payload,
      };
    case OP.MERCHANT_PROPERTIES_RESET:
      return {
        ...state,
        merchantPropertiesStatus: STATUS.DEFAULT,
        merchantPropertiesResult: null,
        merchantPropertiesErrorMessage: "",
      };

    // *-------- > create merchant property reducers
    case OP.CREATE_MERCHANT_PROPERTY_LOADING:
      return {
        ...state,
        createMerchantPropertyStatus: STATUS.LOADING,
      };
    case OP.CREATE_MERCHANT_PROPERTY_SUCCESS:
      return {
        ...state,
        createMerchantPropertyStatus: STATUS.SUCCESS,
        createMerchantPropertyResult: payload,
        createMerchantPropertyErrorMessage: "",
      };
    case OP.CREATE_MERCHANT_PROPERTY_FAILURE:
      return {
        ...state,
        createMerchantPropertyStatus: STATUS.ERROR,
        createMerchantPropertyResult: null,
        createMerchantPropertyErrorMessage: payload,
      };
    case OP.CREATE_MERCHANT_PROPERTY_RESET:
      return {
        ...state,
        createMerchantPropertyStatus: STATUS.DEFAULT,
        createMerchantPropertyResult: null,
        createMerchantPropertyErrorMessage: "",
      };

    // *-------- > update merchant property reducers
    case OP.UPDATE_MERCHANT_PROPERTY_LOADING:
      return {
        ...state,
        updateMerchantPropertyStatus: STATUS.LOADING,
      };
    case OP.UPDATE_MERCHANT_PROPERTY_SUCCESS:
      return {
        ...state,
        updateMerchantPropertyStatus: STATUS.SUCCESS,
        updateMerchantPropertyResult: payload,
        updateMerchantPropertyErrorMessage: "",
      };
    case OP.UPDATE_MERCHANT_PROPERTY_FAILURE:
      return {
        ...state,
        updateMerchantPropertyStatus: STATUS.ERROR,
        updateMerchantPropertyResult: null,
        updateMerchantPropertyErrorMessage: payload,
      };
    case OP.UPDATE_MERCHANT_PROPERTY_RESET:
      return {
        ...state,
        updateMerchantPropertyStatus: STATUS.DEFAULT,
        updateMerchantPropertyResult: null,
        updateMerchantPropertyErrorMessage: "",
      };

    // *-------- > delete merchant property reducers
    case OP.DELETE_MERCHANT_PROPERTY_LOADING:
      return {
        ...state,
        deleteMerchantPropertyStatus: STATUS.LOADING,
      };
    case OP.DELETE_MERCHANT_PROPERTY_SUCCESS:
      return {
        ...state,
        deleteMerchantPropertyStatus: STATUS.SUCCESS,
        deleteMerchantPropertyResult: payload,
        deleteMerchantPropertyErrorMessage: "",
      };
    case OP.DELETE_MERCHANT_PROPERTY_FAILURE:
      return {
        ...state,
        deleteMerchantPropertyStatus: STATUS.ERROR,
        deleteMerchantPropertyResult: null,
        deleteMerchantPropertyErrorMessage: payload,
      };
    case OP.DELETE_MERCHANT_PROPERTY_RESET:
      return {
        ...state,
        deleteMerchantPropertyStatus: STATUS.DEFAULT,
        deleteMerchantPropertyResult: null,
        deleteMerchantPropertyErrorMessage: "",
      };

    // *-------- > view one merchant transaction reducers
    case OP.VIEW_MERCHANT_TRANSACTION_LOADING:
      return {
        ...state,
        viewMerchantTransactionStatus: STATUS.LOADING,
      };
    case OP.VIEW_MERCHANT_TRANSACTION_SUCCESS:
      return {
        ...state,
        viewMerchantTransactionStatus: STATUS.SUCCESS,
        viewMerchantTransactionResult: payload,
        viewMerchantTransactionErrorMessage: "",
      };
    case OP.VIEW_MERCHANT_TRANSACTION_FAILURE:
      return {
        ...state,
        viewMerchantTransactionStatus: STATUS.ERROR,
        viewMerchantTransactionResult: null,
        viewMerchantTransactionErrorMessage: payload,
      };
    case OP.VIEW_MERCHANT_TRANSACTION_RESET:
      return {
        ...state,
        viewMerchantTransactionStatus: STATUS.DEFAULT,
        viewMerchantTransactionResult: null,
        viewMerchantTransactionErrorMessage: "",
      };

    default:
      return state;
  }
};

export default merchantReducers;
